/// <reference types="node" />
export const CLIENT_VERSION = process.env._PACKAGE_VERSION_ as string;
